import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2, Package, Mail } from "lucide-react";
import { gbp } from "@/lib/api";

export default function OrderConfirmation() {
  const { state } = useLocation();
  const order = state?.order;
  if (!order) return <Navigate to="/" replace />;

  return (
    <div className="container-furn py-16">
      <div className="mx-auto max-w-2xl">
        <div className="flex flex-col items-center text-center">
          <CheckCircle2 className="h-16 w-16 text-accent" />
          <h1 className="mt-5 font-display text-4xl font-bold uppercase tracking-tight">Order Confirmed</h1>
          <p className="mt-3 text-muted-foreground">Thank you! Your order <b className="text-foreground" data-testid="order-number">#{order.order_number}</b> has been placed. A confirmation has been sent to {order.shipping.email}.</p>
          {order.points_earned ? <p className="mt-2 text-sm text-accent">You earned {order.points_earned} loyalty points on this order.</p> : null}
        </div>

        <div className="mt-10 border border-border bg-card">
          <div className="border-b border-border p-5">
            <div className="flex items-center gap-2 font-display text-lg font-semibold uppercase"><Package className="h-5 w-5 text-accent" /> Order Summary</div>
          </div>
          <div className="divide-y divide-border">
            {order.items.map((i) => (
              <div key={i.product_id} className="flex items-center gap-3 p-4">
                <div className="h-14 w-14 shrink-0 overflow-hidden bg-secondary"><img src={i.image} alt="" className="h-full w-full object-cover" /></div>
                <div className="flex-1 text-sm"><p className="font-medium">{i.name}</p><p className="text-muted-foreground">Qty {i.quantity}</p></div>
                <span className="text-sm font-semibold">{gbp(i.price * i.quantity)}</span>
              </div>
            ))}
          </div>
          <div className="space-y-2 border-t border-border p-5 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Subtotal</span><span>{gbp(order.subtotal)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Delivery ({order.shipping.method})</span><span>{order.delivery === 0 ? "FREE" : gbp(order.delivery)}</span></div>
            <div className="flex justify-between border-t border-border pt-2 font-display text-lg font-bold"><span>Total Paid</span><span>{gbp(order.total)}</span></div>
          </div>
        </div>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link to="/shop" className="bg-accent px-8 py-4 text-center text-xs font-bold uppercase tracking-widest text-accent-foreground">Continue Shopping</Link>
          <Link to="/account" className="border border-border px-8 py-4 text-center text-xs font-bold uppercase tracking-widest hover:border-accent transition-colors">View My Orders</Link>
        </div>
        <p className="mt-6 flex items-center justify-center gap-2 text-xs text-muted-foreground"><Mail className="h-3.5 w-3.5" /> Questions? sales@furnangling.co.uk</p>
      </div>
    </div>
  );
}
